import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { toUpper } from 'lodash'

const FacebookLinkComponent = (props) => {
  const {card, mobileView = false, onLoaded, isTinyMedia = false, callToAction} = props
  
  if (!card || !card.media?.url) return null
  
  return (
    <div className={`link ${isTinyMedia ? 'tiny-media' : ''} carousel-preview-item facebook-${mobileView ? 'mobile' : 'desktop'}`}>
      {card.media?.type?.includes('video') ? (
        <video
          className="media"
          src={card.media.url}
          autoPlay
          loop
          muted
          playsInline
          onLoad={onLoaded}
        />
      ) : (
        <LazyLoadImage
          className="media"
          alt={card.media.filename}
          src={card.media.url}
          height={card.media.height}
          width={card.media.width}
          onLoad={onLoaded}
        />
      )}
      <div className="order-now">
        <div className="text d-flex flex-column gap-1">
          <div className="url" title={card.url}>
            {mobileView ? card.url : toUpper(card.url)}
          </div>
          <div className="headline">{card.headline}</div>
        </div>
        <div className="button">{callToAction}</div>
      </div>

    </div>
  )
}

export default FacebookLinkComponent